import { useEffect, useState } from "react";
import { classNames } from "../../helpers";
import DropDown from "../forms/dropdown/DropDown";
import ShowIf from "../show-if/ShowIf";
import { useLocation } from "react-router-dom";
type tabsProps = {
  tabs: {
    name: string;
    cypressSelector?: string;
    content: JSX.Element;
    counter?: number;
  }[];
  defaultTab?: number;
  showDropDownOnMobile?: boolean;
  className?: string;
  requests?: boolean;
  isFlexCol?: boolean;
  stickyPosition?: boolean;
};
export default function TabsComponent(props: tabsProps) {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const {
    tabs,
    defaultTab,
    requests,
    showDropDownOnMobile = true,
    className,
    isFlexCol =true,
    stickyPosition,
  } = props;
  const [currentTab, setCurrentTab] = useState(defaultTab || 0);

  useEffect(() => {
    setCurrentTab(Number(searchParams.get("tab")));
  }, [searchParams.get("tab")]);

  const tabClick = (idx: number) => {
    const pathname = location.pathname;
    searchParams.set("tab", String(idx));
    searchParams.set("page", "1");
    window.history.replaceState(
      null,
      "",
      `${pathname}?${searchParams.toString()}`
    );
    setCurrentTab(idx);
  };

  return (
    <div className={classNames("w-full flex flex-col min-h-full", className)}>
      <div
        className={classNames(
          "w-full  z-50 sm:border-b border-gray-200 ",
          !!requests ? "px-8 bg-white" : "bg-white",
          !!stickyPosition ? "" : "sm:top-0  sm:sticky"
        )}
      >
        <ShowIf condition={showDropDownOnMobile}>
          <div className="sm:hidden">
            <DropDown
              id="tabs"
              name="tabs"
              schema={{}}
              register={() => {}}
              setValue={(value: number) => {
                setCurrentTab(value);
              }}
              defaultValue={currentTab}
              options={tabs.map((tab, idx) => ({ key: tab.name, value: idx }))}
            />
          </div>
        </ShowIf>
        <div className={`${showDropDownOnMobile && "hidden sm:block"}`}>
          <div className="">
            <nav
              className="flex -mb-px space-x-8 rtl:space-x-reverse"
              aria-label="Tabs"
            >
              {tabs.map((tab, idx) => (
                <button
                  data-cy={tab?.cypressSelector}
                  key={tab.name}
                  className={classNames(
                    idx === currentTab
                      ? "border-brandblue-500 text-brandblue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                    "whitespace-nowrap flex flex-row gap-2 justify-between  pb-4 px-1 border-b-2 font-medium text-sm"
                  )}
                  onClick={() => tabClick(idx)}
                >
                  {!!tab?.counter && (
                    <div
                      className={classNames(
                        idx === currentTab
                          ? "bg-indigo-100 text-brandblue-600"
                          : "text-gray-800 bg-gray-100 ",
                        "w-7 h-5 text-center  rounded-full ltr:mr-auto rtl:mr-auto"
                      )}
                    >
                      {tab?.counter}
                    </div>
                  )}
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>
        </div>
      </div>
      <div className={classNames("w-full h-full",isFlexCol && "flex flex-col")}>
        {tabs[currentTab]?.content}
      </div>
    </div>
  );
}
